/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.GiftCardTypes {
    "use strict";

    export class GiftCardTypesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        private busyService: Meevo.Components.Busy.IBusyService;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected discountsService: Meevo.Plugins.Discounts.IDiscountsService,
            busyService: Meevo.Components.Busy.IBusyService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            this.busyService = busyService;
            //this.baseEndpoint = appSettings.API_ENDPOINTS.blockType + '/' + this.selectedSection.model.id + '/Locations';
            this.baseEndpoint = appSettings.API_ENDPOINTS.giftCardType;
            this.sectionTemplatePath = "app/plugins/giftCardTypes/sectionViews/";

            this.buildCrudSecurityKeys(this.securityKeys.DATA_GIFTCARDTYPE_TAB_MAIN);
            this.entityType = 'GiftCardType';   

            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_GIFTCARDTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_GIFT_CARD_TYPE_MAIN",
                    "main.html",
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.giftCardType,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.GiftCardTypeMain,
                    this.busyService,
                    this.discountsService,
                    null,
                    this.securityKeys.DATA_GIFTCARDTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }
    }
}